import React, { useContext, useEffect, useState } from 'react'
import { Button, useErrorService } from '@abroad/components'
import AssignSOWSection from './AssignSOWSection'
import { AssignCoachPairingModal } from '../common'
import { OrgEcoIdsContext } from '../../utils/contexts'
import API from '../../utils/API'

const AssignCoachSOWButton = ({ ...props }) => {
  const { ids, setIsLoadNewData, setIds } = useContext(OrgEcoIdsContext)
  const [showCoachModal, setShowCoachModal] = useState(false)
  const [usersHasNoCoach, setUsersHasNoCoach] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [coachId, setCoachId] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedUsers, setSelectedUsers] = useState([])
  const [userCoachAssignments, setUserCoachAssignments] = useState([])
  const [pairingCoaches, setPairingCoaches] = useState([])
  const [pairingSchedulingMeta, setPairingSchedulingMeta] = useState(null)
  const Error = useErrorService()

  // Reset function to clear all state and refresh page
  const handleResetAndRefresh = () => {
    setUserCoachAssignments([])
    setSelectedUsers([])
    setCoachId(null)
    setPairingCoaches([])
    setPairingSchedulingMeta(null)
    setIds([])
    setIsLoadNewData(true)
  }

  useEffect(() => {
    if (!showModal) {
      setCoachId(null)
    }
  }, [showModal])

  useEffect(() => {
    const selectedUsersHasNoCoach = props.userCoachMapping.every(
      (user) => user?.coachId === undefined,
    )
    setUsersHasNoCoach(selectedUsersHasNoCoach)

    // Get selected users data from the table
    if (props.selectedUsersData) {
      setSelectedUsers(props.selectedUsersData)
    }
  }, [ids, props.userCoachMapping, props.selectedUsersData])

  const handleAssignCoach = async (
    coach,
    coaches,
    specificUserIds = null,
    schedulingMeta = null,
  ) => {
    setIsLoading(true)
    try {
      // Check if this is coming from AssignCoachModal with coach assignments
      if (
        Array.isArray(specificUserIds) &&
        specificUserIds.length > 0 &&
        !coach
      ) {
        // Coming from AssignCoachModal's Next button with all coach assignments
        const assignments = specificUserIds.map(({ userId, coachId }) => ({
          clientId: userId,
          coachId: coachId,
        }))

        setUserCoachAssignments(assignments)
        setPairingCoaches(coaches || [])
        setPairingSchedulingMeta(schedulingMeta)
        setShowCoachModal(false)

        // Show the SOW modal

        setShowModal(true)
        setIsLoading(false)
        return
      }

      const userIds = specificUserIds || ids

      if (userIds && userIds.length > 0) {
        // Coming from AssignCoachModal's Next button with single coach
        setCoachId(coach)
        setShowCoachModal(false)

        // Show the SOW modal
        setShowModal(true)
        return
      }

      // Original API call for direct coach assignment
      const { data } = await API.AdminAPI.common.bulkAssignCoachToUser({
        userIds: userIds,
        coachId: coach,
      })

      if (data) {
        setCoachId(coach)
        if (props?.type === 'company') {
          setIsLoadNewData(true)
        } else if (usersHasNoCoach) {
          setShowModal(true)
        } else {
          setIsLoadNewData(true)
        }
      }
    } catch (e) {
      Error.showError(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className='d-flex'>
        <div className='d-none'>
          <AssignSOWSection
            {...props}
            showModal={showModal}
            setShowModal={setShowModal}
            usersHasNoCoach={usersHasNoCoach}
            usersHasOneCoach={true}
            coachId={coachId}
            userCoachMapping={
              userCoachAssignments.length > 0
                ? userCoachAssignments
                : selectedUsers
            }
            pairingCoaches={pairingCoaches}
            pairingSchedulingMeta={pairingSchedulingMeta}
            showCoachModal={showCoachModal}
            setShowCoachModal={setShowCoachModal}
            onResetAndRefresh={handleResetAndRefresh}
          />
        </div>

        <Button
          variant='saffron'
          size='md'
          className='line-height-normal assign-btn ml-2 px-3'
          style={{ height: '2rem' }}
          onClick={() => setShowCoachModal(true)}
          isLoading={isLoading}
          disabled={ids?.length === 0 || isLoading}>
          Coach Pairing
        </Button>
      </div>
      <AssignCoachPairingModal
        handleAssignCoach={handleAssignCoach}
        isSubmitting={isLoading}
        showModal={showCoachModal}
        setShowModal={setShowCoachModal}
        selectedUsers={selectedUsers}
        userCoachMapping={props.userCoachMapping}
        onResetAndRefresh={handleResetAndRefresh}
      />
    </>
  )
}

export default AssignCoachSOWButton
